import Alert from '@anm/components/notification/Alert';
import { getUpgradeMessage, LimitName } from '@anm/data/profile/subscriptionLimits';
import { FC } from 'react';

const UpgradeAlert: FC<{ name: LimitName }> = ({ name }) => (
  <Alert position="left" variant="warning">
    {getUpgradeMessage(name)}
  </Alert>
);

export default UpgradeAlert;
